import RegistrationInfoBox from './RegistrationInfoBox';

export default RegistrationInfoBox;
